enum MODIFICATION {
  UPDATE,
  DELETE,
  ADD,
}

export default MODIFICATION;
